// extracted by mini-css-extract-plugin
export default {"footer":"footer__DGBa9","fade-in":"fade-in__62tZC","container":"container__eare5"};